import Page from "./Page";

export default class View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     */
    constructor(parentId, elementId) {
        /**
         * @private
         * @type {string}
         */
        this.parentId = parentId;
        /**
         * @private
         * @type {string}
         */
        this.elementId = elementId;
        /**
         * @private
         * @type {boolean}
         */
        this.viewVisible = true;
        /**
         * True if the element represented by 'elementId' is currently visible on the page.
         * @private
         * @type {boolean}
         */
        this.currentlyVisible = false;

        /**
         * @private
         * @type {boolean}
         */
        this.inialized = false;
    }

    /**
     * @returns {string}
     */
    getElementId() {
        return this.elementId;
    }

    /**
     * @param {boolean} currentlyVisible
     */
    setCurrentlyVisible(currentlyVisible) {
        this.currentlyVisible = currentlyVisible;
    }

    /**
     * Returns true if the element should or should not be visible on the page.
     * @returns {boolean}
     */
    isViewVisible() {
        return this.viewVisible;
    }

    /**
     * Set to true if the element should be visible on the page.
     * @param {boolean} visible
     */
    setViewVisible(visible) {
        this.viewVisible = visible;
    }

    /**
     * Set the initial visibility of the element.
     * @param {boolean} visible
     */
    setInitialVisibility(visible) {
        this.currentlyVisible = !visible;
        this.viewVisible = visible;
    }

    /**
     * @abstract
     */
    clearChildViews() {
    }

    /**
     * Updates the user interface to reflect the data in the model.
     */
    updateView() {
        if (!this.inialized) {
            console.log('View.updateView() Not initialized: ' + this.constructor.name);
        }

        if (this.elementId) {
            // Ask the child class if this element should be visible.
            var viewVisible = this.isViewVisible();
            if (this.currentlyVisible !== viewVisible) {
                this.currentlyVisible = viewVisible;
                if (viewVisible) {
                    ///////Page.showElementId(this.elementId);
                    Page.showElementIdWithValue(this.elementId, this.getVisibileDisplayValue());
                }
                else {
                    Page.hideElementId(this.elementId);
                }
            }

            // Only update the view if it is visible.
            if (viewVisible) {
                this.updateViewContents();
            }
        }
    }

    /**
     * Returns the value that the display property should be set to in order to make
     * the element visible. 
     * 
     * By default this is 'block', but you should overwrite this if the element is 'display:flex', or 'display:inline-block' 
     * or something other than 'display:block'.
     * 
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'block';
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @abstract
     */
    initializeView() {
        this.inialized = true;
    }


    /**
     * Invoked by the base view if the element is visible on the page.
     * @abstract
     */
    updateViewContents() {
        // Overridden by child views.
    }

    /**
     */
    removeAll() {
        if (this.parentId) {
            Page.removeElementById(this.parentId, this.elementId);
        }
    }
}